import React from 'react';

const IconHex = () => (
  <svg
    id="gab-logo"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 100 100"
    width="42"
    height="42">
    <title>Gab Logo</title>
    <rect width="100" height="100" rx="12" ry="12" fill="currentColor" />
    <text
      x="50%"
      y="50%"
      dominantBaseline="middle"
      textAnchor="middle"
      fontSize="40"
      fontFamily="Arial, Helvetica, sans-serif"
      fill="#0a192f" // your background navy color for contrast
      fontWeight="bold">
      GAB
    </text>
  </svg>
);

export default IconHex;
